<div class="prom-accordion">
    <slot />
</div>
